import styled from 'styled-components';

import { colors } from 'global/colors';

export const SortingWrapper = styled.div`
  display: flex;
`;

export const SortingIcon = styled.div`
  height: 36px;
  min-width: 32px;
  width: 32px;
  background: ${colors.white};
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  margin-left: 10px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  :after {
    content: '${(props) => (props.descendingOrder ? '\f078' : '\f077')}';
    font-family: FontAwesome;
    font-size: 18px;
    position: relative;
    top: 3px;
    color: ${colors.darkGray};
  }
`;

export const SortingContainer = styled.div`
  position: relative;
  width: 130px;
  height: 36px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  background: ${colors.white};

  :after {
    position: absolute;
    top: 4px;
    right: 10px;
    content: '\f0d7';
    font-family: FontAwesome;
    color: ${colors.darkGray};
    margin-left: 5px;
    pointer-events: none;
  }
  :focus-within {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  }
`;

export const SortingInput = styled.select`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  appearance: none;
  background: transparent;
  padding: 3px 8px;
  font-size: 16px;
  height: 100%;
  color: ${colors.darkGray};
  border: none;
  width: 100%;
  outline: none;
`;
